<template>
  <div>
    <v-dialog persistent v-model="show" width="640">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">
          {{ titulo }}
        </v-card-title>
        <v-card-text>
          <div v-html="message"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="save">
            Sim
          </v-btn>
          <v-btn text color="primary" v-if="showClose" @click="close">
            não
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ModalCartaPortabilidade",
  props: {
    message: String,
    show: Boolean,
    showClose: { Boolean, default: true },
    showOverwrite: { Boolean, default: false },
    titulo: String
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save");
    }
  }
};
</script>
